import localforage from 'localforage';
import { ref } from 'vue';
import { defineStore } from 'pinia';

import { calculationService } from '../utils/api/calculationService';

import type { Calculator } from '../utils/types';

export const useCalculatorsStore = defineStore(
  'calculators',
  () => {
    const data = ref<Calculator[] | null>(null);

    async function getCalculatorsFromLocalforage() {
      await localforage.getItem<Calculator[]>('calculators');
    }

    async function fetchCalculators() {
      await getCalculatorsFromLocalforage();

      if (data.value) return;

      data.value = await calculationService.getCalculators();
    }

    function invalidate() {
      data.value = null;

      fetchCalculators();
    }

    return {
      data,
      fetchCalculators,
      invalidate,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
